var unirest = require('unirest');
const API = require ('Api') ;

// FIXME Corrgit estas variables a API
const apiBase = process.env.REACT_APP_API_BASE ;
const apiv2 = process.env.REACT_APP_API_URL;

const logbookBase = 'logbook/';
const endpointBase = 'students/' ;
const reportsEndpoint = 'reports/';
const filesEndpoint = 'files/';

export async function getStudentBrief ( token, personaID , calendarID) {
    const res =  await unirest.get(apiBase + endpointBase  + personaID + "/brief" )
            .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let brief = res.body ;
    // Add Images to persona
    const images = await unirest.get(apiv2 + filesEndpoint   + personaID + "/images" )
        .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'})

    brief.persona.images = images.body ; 

return brief ;
}



export async function getStudentQualifReport ( token, personaID, calendarID ) {
    const res =  await unirest.get(apiBase + reportsEndpoint + "qualifReport/" + personaID )
            .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'})
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getStudentLogbookReport ( token, personaID, calendarID ) {
    const res =  await unirest.get(apiv2 + logbookBase + "report/" + personaID )
            .headers({'Authorization': 'Bearer ' + token, 
            'crrntcal':calendarID, 
            'Content-Type': 'application/json'})
            if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}


// Asistencias

export async function getStudentAttendance ( token, studentID, calendarID )  {
    const res =  await unirest.get(API.V2 + API.ATTENDANCE + "students/" + studentID )
                .headers({'Authorization': 'Bearer ' + token,
                'crrntcal':calendarID,
                'Content-Type': 'application/json'});
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

// Nuevo api de evaluaciones

export async function getCourseEvaluations ( token, studentCourseID ) {
    const res =  await unirest.get(API.V2 + API.EVALUATIONS + studentCourseID + "/evaluations")
                .headers({'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'});
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getMyEvaluations ( token, calendarID ) {
    const res =  await unirest.get(API.V2 + API.EVALUATIONS + 'me')
                .headers({'Authorization': 'Bearer ' + token, 'crrntcal':calendarID, 'Content-Type': 'application/json'});
    if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}

export async function getStudentEvaluationReport ( token, courseID, studentID, calendarID, extra ) {

  
//  const res =  await unirest.get("http://0.0.0.0:3006/dev/"+ courseID+ "/" +studentID +"/report?extra="+extra  )
      
const res =  await unirest.get(API.V2 + API.EVALUATIONS + courseID+ "/" +studentID + "/report?extra="+extra  )
              .headers({'Authorization': 'Bearer ' + token, 
              'crrntcal':calendarID, 
              'Content-Type': 'application/json'})
              if (res.error) console.log(res.error)
      let list = res.body ;
  return list ;
  }


export async function getMyEvaluationReport ( token, calendarID, extra ) {

  
//    const res =  await unirest.get("http://0.0.0.0:3006/dev/me/report?extra="+extra  )
    
const res =  await unirest.get(API.V2 + API.EVALUATIONS + "me/report?extra=" + extra )
            .headers({'Authorization': 'Bearer ' + token, 
            'crrntcal':calendarID, 
            'Content-Type': 'application/json'})
            if (res.error) console.log(res.error)
    let list = res.body ;
return list ;
}